<template>
  <div class="box" v-on:click="expandDetails()">
    <p class="date">{{ date }}</p>
    <h2>{{ title }}</h2>
    <p class="article-text" v-if="expanded">{{ contents }}</p>
    <p class="article-button" v-if="!expanded">Expand Details</p>
    <p class="article-button" v-if="expanded" v-on:click="closeDetails($event)">Close</p>
    <div class="tags df fdr">
      <p class="tag"  v-for="(item, key) in tags"
                      v-bind:key="key">{{ item }}</p>
    </div>
  </div>
</template>

<script>
// import Login from '../components/Login'

export default {
  name: 'NewsArticle',
  data () {
    return {
      expanded: false
    }
  },
  props: ['author', 'contents', 'date', 'tags', 'title'],
  components: {

  },
  methods: {
    expandDetails () {
      this.expanded = true
    },
    closeDetails (e) {
      e.stopPropagation()
      this.expanded = false
    }
  },
  computed: {

  },
  created () {
    // console.log('** Login Component Loaded')
  }
}
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  padding: 30px;
  position: relative;
}
.date {
  color: #000000;
  font-size: 12px;
  letter-spacing: 0.21px;
  line-height: 14px;
}
h2 {
  color: #000000;
  font-size: 24px;
  line-height: 36px;
}
.article-text {
  color: #000000;
  font-size: 16px;
  line-height: 21px;
  margin-top: 40px;
  margin-bottom: 40px;
}
.article-button {
  color: #0874D8;
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
  text-transform: uppercase;
}
.tags {
  position: absolute;
  top: 10px;
  right: 10px;
}
.tag {
  background-color: #d9edff;
  border-radius: 4px;
  padding: 5px;
  color: #0874D8;
  font-size: 10px;
  font-weight: bold;
  line-height: 11px;
  margin-left: 10px;
}
</style>
